import './otherhubs.scss';
import {CarouselUtils} from '../../Shared/Assets/carousel-utils';

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
Swiper.use([Navigation, Pagination]);

class OtherHubsCarousel {
    init() {
        const sectionEl = document.querySelector('[data-role="otherhubs-carousel-section"]');
        this.buildCarousel(sectionEl);
    }
    buildCarousel(sectionEl) {
        if (CarouselUtils.isMobile()) {
            sectionEl.classList.add('has-touch');
        } else {
            sectionEl.classList.remove('has-touch');
        }

        const swiperSectionEl = sectionEl.querySelector('[data-role="swiper-section"]');
        const configs = this.getConfigs(sectionEl,swiperSectionEl);
        const swiperEl = swiperSectionEl.querySelector('[data-role="swiper"]');
        const swiper = new Swiper(swiperEl,configs);
    }
    getConfigs(sectionEl,swiperSectionEl) {
        if (CarouselUtils.isMobile()) {
            const slidesOffset = CarouselUtils.getSlidesOffset(sectionEl);
            const spaceBetween = 8;
            const slides = 1;
            return {
                //https://swiperjs.com/swiper-api
                edgeSwipeDetection: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                roundLengths: true,

                //responsive
                slidesPerView: slides,
                spaceBetween,
                slidesOffsetBefore: slidesOffset,
                slidesOffsetAfter: slidesOffset
            }
        }

        //desktop
        const pagination = CarouselUtils.usePagination(swiperSectionEl);
        const navigation = CarouselUtils.useNavs(swiperSectionEl, CarouselUtils.isLargeScreen());
        const totalSlides = swiperSectionEl.querySelectorAll('[data-role="swiper-slide"]').length;
        const slidesPerViewLg = CarouselUtils.getValueInRange(totalSlides, 3, 4);
        return {
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            roundLengths: true,
            speed:500,
            slidesPerView: 1.1,
            slidesPerGroup: 1,
            spaceBetween: 16,
            pagination,
            navigation,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                1200: {
                    slidesPerView: slidesPerViewLg,
                    slidesPerGroup: slidesPerViewLg
                }
            },
        };
    }
}

window.addEventListener("load", () => new OtherHubsCarousel().init());